export default __webpack_public_path__ + "static/media/Drop.4221f069.svg";